export const truncateNumber = (inputNumber, digit = 2) => {
    let numberString = inputNumber.toString();
    if (numberString.includes('.')) numberString = numberString.slice(0, numberString.indexOf('.') + digit + 1);
    return Number(numberString);
};
